import _defineProperty from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import * as tslib_1 from "tslib";
import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import { forwardRefAs, Generic } from "../../base";
import { DEFAULTS } from "../../base/helpers/variables";
export var COLUMN_GROUP_DEFAULTS = {
  gapSizes: [0, 1, 2, 3, 4, 5, 6, 7, 8]
};
export var ColumnGroup = forwardRefAs(function (_a, ref) {
  var _classNames2;

  var className = _a.className,
      breakpoint = _a.breakpoint,
      centered = _a.centered,
      desktop = _a.desktop,
      fullhd = _a.fullhd,
      gapless = _a.gapless,
      gapSize = _a.gapSize,
      mobile = _a.mobile,
      multiline = _a.multiline,
      tablet = _a.tablet,
      widescreen = _a.widescreen,
      touch = _a.touch,
      vcentered = _a.vcentered,
      rest = tslib_1.__rest(_a, ["className", "breakpoint", "centered", "desktop", "fullhd", "gapless", "gapSize", "mobile", "multiline", "tablet", "widescreen", "touch", "vcentered"]);

  var breakpoints = {
    desktop: desktop,
    fullhd: fullhd,
    mobile: mobile,
    tablet: tablet,
    touch: touch,
    widescreen: widescreen
  };
  var gapSizeClassNames = classNames(_defineProperty({}, "is-".concat(gapSize), typeof gapSize === "number"), Object.keys(breakpoints).map(function (key) {
    var value = breakpoints[key];
    return value === undefined ? {} : _defineProperty({}, "is-".concat(value.gapSize, "-").concat(key), value.gapSize !== undefined);
  }).reduce(function (acc, cv) {
    return Object.assign({}, acc, cv);
  }, {}));
  return React.createElement(Generic, Object.assign({
    className: classNames("columns", (_classNames2 = {}, _defineProperty(_classNames2, "is-".concat(breakpoint), breakpoint), _defineProperty(_classNames2, "is-centered", centered), _defineProperty(_classNames2, "is-gapless", gapless), _defineProperty(_classNames2, "is-multiline", multiline), _defineProperty(_classNames2, "is-variable ", gapSizeClassNames !== ""), _defineProperty(_classNames2, "is-vcentered", vcentered), _classNames2), gapSizeClassNames, className),
    ref: ref
  }, rest));
}, {
  as: "div"
});
ColumnGroup.displayName = "Column.Group";
var ColumnGroupBreakpointPropTypes = {
  gapSize: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
ColumnGroup.propTypes = Object.assign({}, DEFAULTS.breakpoints.map(function (breakpoint) {
  return _defineProperty({}, breakpoint, PropTypes.shape(ColumnGroupBreakpointPropTypes));
}).reduce(function (acc, cv) {
  return Object.assign({}, acc, cv);
}, {}), ColumnGroupBreakpointPropTypes, {
  breakpoint: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  centered: PropTypes.bool,
  gapless: PropTypes.bool,
  multiline: PropTypes.bool,
  vcentered: PropTypes.bool
});